import ScrollReveal from '@/components/effects/ScrollReveal';
import { Link } from 'react-router-dom';

export default function Welcome() {
  return (
    <div data-testid="welcome-page" className="min-h-screen" dir="rtl" lang="ar" style={{ fontFamily: "'Amiri', 'Noto Sans Arabic', serif" }}>

      {/* COVER */}
      <section className="relative py-24 md:py-36 px-4 text-center" style={{ background: 'linear-gradient(180deg, #FFF8E1 0%, #F5ECD0 100%)' }}>
        <ScrollReveal>
          <div className="max-w-2xl mx-auto">
            <p className="text-warm-brown/60 text-sm font-body mb-4">دليل طارق أبو فياض</p>
            <h1 className="text-4xl sm:text-5xl lg:text-6xl text-heading mb-6" style={{ fontFamily: "'Amiri', 'Noto Sans Arabic', serif", lineHeight: 1.4 }}>
              مركز الجاذبية
            </h1>
            <div className="w-16 h-[2px] bg-sacred-gold mx-auto mb-6" />
            <p className="text-warm-brown text-lg leading-relaxed max-w-lg mx-auto mb-4">
              كيف تتوقف عن مطاردة الانتباه<br />وتصبح المكان الذي يتجمّع حوله الناس
            </p>
            <p className="text-sacred-gold text-sm">هدية مجانية — من القلب إليك</p>
          </div>
        </ScrollReveal>
      </section>

      {/* MESSAGE FROM TARIQ */}
      <section className="py-16 md:py-24 px-4" style={{ background: '#FFFDF5' }}>
        <div className="max-w-2xl mx-auto">
          <ScrollReveal>
            <h2 className="text-2xl font-display text-heading text-center mb-2" style={{ fontFamily: "'Amiri', serif" }}>رسالة من طارق</h2>
            <div className="w-12 h-[2px] bg-sacred-gold mx-auto mb-8" />
          </ScrollReveal>
          <ScrollReveal delay={0.1}>
            <div className="text-warm-brown leading-[2] text-base space-y-4" style={{ textAlign: 'right' }}>
              <p>أعرف كيف تشعر حين تبذل كل ما عندك — ومع ذلك لا يلتفت أحد.</p>
              <p>أعرف كيف يكون الشعور بأنك <strong className="text-deep-brown">عالق في مكانك</strong> — تملك القدرة، تملك الحلم، تعرف أنك تستحق أكثر... لكن شيئاً ما يمنعك من أن تُرى كما أنت.</p>
              <p>لسنوات عشتُ نفس هذا الإحساس. كنت أفهم الناس أسرع مما أفهم نفسي. أعرف ماذا يريدون، وأرى كيف تتحوّل احتياجاتهم إلى حركة — لكنني لم أجد بعد <strong className="text-deep-brown">نقطة ارتكازي</strong>.</p>
              <p>هذا الدليل ليس كل الطريق — بل هو المرآة التي تكشف لك <strong className="text-deep-brown">لماذا تشعر بأن كل شيء ثقيل</strong>، ومن أين يبدأ التغيير الحقيقي. كتبته لك بصدق، بامتنان، وبثقة أنك تستحق أن تسمع هذا الكلام.</p>
            </div>
          </ScrollReveal>
        </div>
      </section>

      {/* TABLE OF CONTENTS */}
      <section className="py-16 md:py-24 px-4" style={{ background: '#F5ECD0' }}>
        <div className="max-w-xl mx-auto">
          <ScrollReveal>
            <h2 className="text-2xl font-display text-center mb-2" style={{ fontFamily: "'Amiri', serif", color: '#2C1810' }}>ماذا ستجد هنا</h2>
            <div className="w-12 h-[2px] mx-auto mb-8" style={{ background: '#2C1810' }} />
          </ScrollReveal>
          {[
            { title: 'المطاردة مقابل الجاذبية', desc: 'لماذا كل ما تفعله يبدو كأنه لا يكفي — وكيف تتحول من مطاردة الانتباه إلى جذبه.' },
            { title: 'الخوف المتخفّي', desc: 'العدو الصامت الذي يمنعك من الحركة — كيف تتعرف عليه وتصادقه.' },
            { title: 'إعادة ضبط الاتجاه', desc: 'ثلاث خطوات عملية للخروج من التشتت والعودة إلى وضوحك الداخلي.' },
            { title: 'القوانين الخمسة للانتباه', desc: 'القوى التي تحكم كل حضور حقيقي — لمحة مع تمرين لكل قانون.' },
            { title: 'النيّة والفكر', desc: 'كيف توجّه عقلك بدلاً من أن يقودك — وما الذي يصنع الفرق.' },
            { title: 'أسئلة التحوّل', desc: 'أسئلة عميقة تكشف ما يمنعك وتوضّح ما تريده فعلاً.' },
            { title: 'الخطوة التالية', desc: 'حيث يتحوّل كل ما قرأته إلى هوية جديدة.' },
          ].map((item, i) => (
            <ScrollReveal key={i} delay={0.05 * (i + 1)}>
              <div className="py-4 border-b border-black/8">
                <div className="font-bold text-lg mb-1" style={{ color: '#2C1810' }}>{item.title}</div>
                <div className="text-sm leading-relaxed" style={{ color: '#8B6914' }}>{item.desc}</div>
              </div>
            </ScrollReveal>
          ))}
        </div>
      </section>

      {/* CHASE VS GRAVITY */}
      <section className="py-16 md:py-24 px-4" style={{ background: '#F5ECD0' }}>
        <div className="max-w-2xl mx-auto">
          <ScrollReveal>
            <div className="text-sacred-gold text-3xl font-bold text-center mb-2">١</div>
            <h2 className="text-2xl font-display text-center mb-2" style={{ fontFamily: "'Amiri', serif", color: '#2C1810' }}>المطاردة مقابل الجاذبية</h2>
            <div className="w-12 h-[2px] mx-auto mb-8" style={{ background: '#2C1810' }} />
          </ScrollReveal>
          <ScrollReveal delay={0.1}>
            <div className="text-warm-brown leading-[2] text-base space-y-4" style={{ textAlign: 'right' }}>
              <p>معظم الناس يعيشون في حالة مطاردة دائمة — يطاردون الانتباه، الظهور، الاعتراف. <strong className="text-deep-brown">يتحركون بلا توقف</strong>، لكنهم لا يتقدمون.</p>
              <p>المطاردة تبدأ حين تظهر لأنك <strong className="text-deep-brown">تخاف أن تُنسى</strong>. تستمر لأنك تخاف أن تفقد ما بنيته.</p>
              <p><strong className="text-deep-brown">تظن أنك تريد النجاح، لكنك في الحقيقة تطارد الإحساس الذي رافقه.</strong> والفرق كبير.</p>
              <p>الجاذبية مختلفة. تبدأ من الداخل. حين يكون حضورك واضحاً ومتماسكاً — الانتباه يأتي إليك. <strong className="text-deep-brown">القدرة على الانسحاب بثقة لا تقل أهمية عن القدرة على الظهور بقوة.</strong></p>
            </div>
          </ScrollReveal>
          <ScrollReveal delay={0.15}>
            <div className="mt-8 p-5 rounded-xl" style={{ background: 'rgba(166,124,0,0.08)', border: '1px solid rgba(166,124,0,0.15)' }}>
              <div className="font-bold text-sm mb-2" style={{ color: '#2C1810' }}>جرّب الآن:</div>
              <p className="text-sm leading-relaxed" style={{ color: '#2C1810' }}>أغلق عينيك لعشر ثوانٍ. اسأل نفسك بصدق: <strong>آخر مرة ظهرت فيها — هل كنت أتحرك من مكان امتلاء أم من مكان جوع؟</strong> لا تحكم على الإجابة. فقط لاحظها.</p>
            </div>
          </ScrollReveal>
        </div>
      </section>

      {/* QUOTE 1 */}
      <section className="py-16 md:py-20 px-4 text-center" style={{ background: 'linear-gradient(180deg, #2C1810 0%, #1a0f08 100%)' }}>
        <ScrollReveal>
          <p className="text-2xl sm:text-3xl max-w-lg mx-auto leading-relaxed" style={{ fontFamily: "'Amiri', serif", color: '#C9A84C' }}>
            الحضور الذي يدوم<br />ليس صاخباً —<br /><span style={{ color: '#A67C00' }}>بل كثيفاً.</span><br />والكثافة هي ما يخلق الجاذبية.
          </p>
        </ScrollReveal>
      </section>

      {/* FEAR */}
      <section className="py-16 md:py-24 px-4" style={{ background: '#2C1810' }}>
        <div className="max-w-2xl mx-auto">
          <ScrollReveal>
            <div className="text-sacred-gold text-3xl font-bold text-center mb-2">٢</div>
            <h2 className="text-2xl font-display text-center mb-2" style={{ fontFamily: "'Amiri', serif", color: '#FFF3CE' }}>الخوف المتخفّي</h2>
            <div className="w-12 h-[2px] bg-sacred-gold mx-auto mb-8" />
          </ScrollReveal>
          <ScrollReveal delay={0.1}>
            <div className="leading-[2] text-base space-y-4" style={{ textAlign: 'right', color: '#F5ECD0' }}>
              <p>قبل أن تبني حضورك — <strong style={{ color: '#C9A84C' }}>يجب أن تواجه ما يمنعك من البدء أصلاً.</strong></p>
              <p>المماطلة. الخوف المتخفي في ثوب الانتظار. الصوت الذي يقول <strong style={{ color: '#C9A84C' }}>«غداً»</strong> و<strong style={{ color: '#C9A84C' }}>«حين أكون جاهزاً»</strong>. هذا العدو لا يصرخ في وجهك. <strong style={{ color: '#C9A84C' }}>هو يهمس</strong>، ولهذا هو خطير.</p>
              <p>لكن وجود الخوف يعني أنك على حافة شيء جديد — <strong style={{ color: '#C9A84C' }}>شيء لم تفعله من قبل، شيء قد يغيّرك.</strong></p>
            </div>
          </ScrollReveal>
          <ScrollReveal delay={0.15}>
            <div className="mt-8 p-5 rounded-xl" style={{ background: 'rgba(245,236,208,0.08)', border: '1px solid rgba(245,236,208,0.1)' }}>
              <div className="font-bold text-sm mb-2" style={{ color: '#F5ECD0' }}>توقّف واسأل:</div>
              <p className="text-sm leading-relaxed" style={{ color: '#F5ECD0' }}>اكتب ثلاثة أشياء تخاف منها الآن. بجانب كل واحد اكتب: <strong>«ماذا سيحدث فعلاً لو فشلت؟»</strong> — ستلاحظ أن أغلب مخاوفك أصغر بكثير مما تبدو.</p>
            </div>
          </ScrollReveal>
        </div>
      </section>

      {/* 3 STEPS */}
      <section className="py-16 md:py-24 px-4" style={{ background: '#F5ECD0' }}>
        <div className="max-w-2xl mx-auto">
          <ScrollReveal>
            <h2 className="text-2xl font-display text-center mb-2" style={{ fontFamily: "'Amiri', serif", color: '#2C1810' }}>ثلاث خطوات</h2>
            <div className="w-12 h-[2px] mx-auto mb-8" style={{ background: '#2C1810' }} />
          </ScrollReveal>
          {[
            { n: '١', title: 'توقّف واسأل', text: 'قبل أن تنشر، قبل أن تتحرك — اسأل: هل أتحرك من مكان امتلاء أم من مكان جوع؟' },
            { n: '٢', title: 'وضّح إشارتك', text: 'ما الذي تريد أن يعرفه الناس عنك؟ ليس كل شيء — شيء واحد. جملة واحدة واضحة.' },
            { n: '٣', title: 'تحرّك بإيقاعك', text: 'الانتباه يعمل ضمن دورات. تظهر، تقدّم قيمة، تُغلق الدورة، ثم تتراجع.' },
          ].map((step, i) => (
            <ScrollReveal key={i} delay={0.1 * (i + 1)}>
              <div className="flex gap-4 mb-6 items-start">
                <div className="w-10 h-10 rounded-full flex items-center justify-center shrink-0 text-lg font-bold" style={{ background: 'rgba(166,124,0,0.12)', color: '#8B6914' }}>{step.n}</div>
                <div>
                  <h3 className="font-bold text-lg mb-1" style={{ color: '#2C1810' }}>{step.title}</h3>
                  <p className="text-sm leading-relaxed text-warm-brown">{step.text}</p>
                </div>
              </div>
            </ScrollReveal>
          ))}
        </div>
      </section>

      {/* 5 LAWS */}
      <section className="py-16 md:py-24 px-4" style={{ background: '#2C1810' }}>
        <div className="max-w-2xl mx-auto">
          <ScrollReveal>
            <div className="text-sacred-gold text-3xl font-bold text-center mb-2">٥</div>
            <h2 className="text-2xl font-display text-center mb-2" style={{ fontFamily: "'Amiri', serif", color: '#FFF3CE' }}>القوانين الخمسة</h2>
            <div className="w-12 h-[2px] bg-sacred-gold mx-auto mb-8" />
          </ScrollReveal>
          {[
            { title: '١. النُدرة', text: 'ما هو متاح بكثرة يفقد تأثيره. وما هو نادر يكتسب قوة جذب.', q: 'أين أُعطي أكثر مما يجب، فيفقد ما أقدّمه وزنه؟' },
            { title: '٢. الجِدّة', text: 'العقل مبرمج على تجاهل التكرار. حين تظهر بشكل مختلف وصادق — يمنحك كامل انتباهه.', q: 'ما الشيء غير المتوقع الذي يمكنني فعله هذا الأسبوع؟' },
            { title: '٣. العاطفة', text: 'المنطق يشرح ويقنع، لكن العاطفة هي التي تحرّك الجسد نحو القرار.', q: 'ما الشعور الذي يحصل عليه الناس حين يتعاملون معي؟' },
            { title: '٤. الوضوح', text: 'أكبر أعداء الانتباه هو الالتباس. البشر يربطون الوضوح بالصدق تلقائياً.', q: 'هل يستطيع شخص غريب أن يفهم ما أفعله من جملة واحدة؟' },
            { title: '٥. المكانة', text: 'حيثما يرى الناس الآخرين يلتفتون — يلتفتون. المكانة الحقيقية تُبنى على عمل حقيقي.', q: 'ما الذي يقوله الناس عني حين لا أكون موجوداً؟' },
          ].map((law, i) => (
            <ScrollReveal key={i} delay={0.08 * (i + 1)}>
              <div className="mb-6 p-5 rounded-xl" style={{ background: 'rgba(245,236,208,0.05)', border: '1px solid rgba(245,236,208,0.08)' }}>
                <h3 className="font-bold text-lg mb-2" style={{ color: '#C9A84C' }}>{law.title}</h3>
                <p className="text-sm leading-relaxed mb-2" style={{ color: '#F5ECD0' }}>{law.text}</p>
                <p className="text-sm italic" style={{ color: '#A67C00' }}>{law.q}</p>
              </div>
            </ScrollReveal>
          ))}
          <ScrollReveal delay={0.5}>
            <p className="text-center text-sm italic mt-6" style={{ fontFamily: "'Amiri', serif", color: '#A67C00', lineHeight: 1.8 }}>
              هذه لمحة فقط. في الكتاب، كل قانون يحمل فصلاً كاملاً مع قصص حقيقية وتطبيقات تغيّر طريقة تفكيرك.
            </p>
          </ScrollReveal>
        </div>
      </section>

      {/* INTENTION */}
      <section className="py-16 md:py-24 px-4" style={{ background: '#F5ECD0' }}>
        <div className="max-w-2xl mx-auto">
          <ScrollReveal>
            <div className="text-sacred-gold/60 text-3xl font-bold text-center mb-2">٦</div>
            <h2 className="text-2xl font-display text-center mb-2" style={{ fontFamily: "'Amiri', serif", color: '#2C1810' }}>النيّة والفكر</h2>
            <div className="w-12 h-[2px] mx-auto mb-8" style={{ background: '#2C1810' }} />
          </ScrollReveal>
          <ScrollReveal delay={0.1}>
            <div className="text-warm-brown leading-[2] text-base space-y-4" style={{ textAlign: 'right' }}>
              <p>النيّة توجّهك بدلاً من أن تدفعك. تحدد أين تنتمي طاقتك وأين تُهدر.</p>
              <p>النيّة تثبّت الانتباه. الأفكار تبدأ بالتنظم حول توجه واحد، <strong className="text-deep-brown">والضجيج الذهني يخف لأنه لم يعد يجد مكاناً يستقر فيه</strong>.</p>
              <p><strong className="text-deep-brown">في هذا التسلسل، النيّة هي القوة التي تبدأ كل شيء.</strong></p>
            </div>
          </ScrollReveal>
        </div>
      </section>

      {/* JOURNAL PROMPTS */}
      <section className="py-16 md:py-24 px-4" style={{ background: '#2C1810' }}>
        <div className="max-w-2xl mx-auto">
          <ScrollReveal>
            <h2 className="text-2xl font-display text-center mb-2" style={{ fontFamily: "'Amiri', serif", color: '#FFF3CE' }}>أسئلة التحوّل</h2>
            <div className="w-12 h-[2px] bg-sacred-gold mx-auto mb-6" />
            <p className="text-center text-sm mb-8" style={{ color: '#C9A84C', maxWidth: 500, margin: '0 auto' }}>هذه ليست أسئلة للقراءة السريعة. ضعها في مفكرتك. اجلس معها بصدق.</p>
          </ScrollReveal>
          {[
            'هل أتحرك اليوم من مكان امتلاء — أم من مكان جوع؟ وكيف أعرف الفرق؟',
            'ما الشيء الواحد الذي أريد أن يعرفه العالم عني — لو كان لدي جملة واحدة فقط؟',
            'أين أُضيّع طاقتي في مطاردة انتباه لا يخدمني — وماذا لو توقفت؟',
            'ما الخوف الذي يرتدي ثوب الحكمة في حياتي الآن — ويمنعني من الخطوة التالية؟',
            'لو كنت واضحاً تماماً — ما الذي سأتوقف عن فعله فوراً؟',
            'ما القصة القديمة عن نفسي التي حان وقت تركها — لأنها لم تعد تصفني؟',
            'ماذا يوجد على الجانب الآخر من مخاوفي — لو تحركت رغمها؟',
            'ما الخطوة الواحدة التي سأتخذها اليوم — ليس لأنني جاهز، بل لأنني مصمّم؟',
          ].map((q, i) => (
            <ScrollReveal key={i} delay={0.05 * (i + 1)}>
              <div className="py-4 px-5 mb-3 rounded-xl text-sm leading-relaxed" style={{ background: 'rgba(245,236,208,0.06)', border: '1px solid rgba(245,236,208,0.08)', color: '#F5ECD0' }}>
                {q}
              </div>
            </ScrollReveal>
          ))}
        </div>
      </section>

      {/* CLOSING QUOTE */}
      <section className="py-16 md:py-20 px-4 text-center" style={{ background: 'linear-gradient(180deg, #1a0f08 0%, #2C1810 100%)' }}>
        <ScrollReveal>
          <p className="text-xl sm:text-2xl max-w-md mx-auto leading-relaxed" style={{ fontFamily: "'Amiri', serif", color: '#C9A84C' }}>
            الخوف حاضر دائماً.<br />ما يتغيّر هو موقعه منك<br />وحدود تأثيره عليك.<br /><br />
            <span className="text-base" style={{ color: '#A67C00' }}>لا تنتظر أن تشعر بالأمان —<br />الأمان الحقيقي يُبنى بالحركة.</span>
          </p>
        </ScrollReveal>
      </section>

      {/* CTA */}
      <section className="py-20 md:py-28 px-4 text-center" style={{ background: '#F5ECD0' }}>
        <div className="max-w-xl mx-auto">
          <ScrollReveal>
            <h2 className="text-2xl font-display mb-2" style={{ fontFamily: "'Amiri', serif", color: '#2C1810' }}>مركز الجاذبية</h2>
            <div className="w-12 h-[2px] mx-auto mb-8" style={{ background: '#2C1810' }} />
            <div className="text-base leading-[2] mb-8 space-y-3" style={{ textAlign: 'right', color: '#8B6914' }}>
              <p>ما قرأته هنا هو البداية فقط.</p>
              <p>الكتاب يحمل <strong style={{ color: '#2C1810' }}>١٢ فصلاً كاملاً</strong> — من قوانين الانتباه إلى المماطلة وكيف تكسر قبضتها، من بناء الذات المغناطيسية إلى الاستحقاق والسمعة.</p>
              <p>كُتب لكل إنسان يعرف أنه يستحق أكثر — ويريد أخيراً أن يُرى كما هو.</p>
            </div>
          </ScrollReveal>
          <ScrollReveal delay={0.15}>
            <Link
              to="/book"
              data-testid="welcome-cta-book"
              className="inline-block gold-button px-8 py-4 rounded-full font-body font-semibold text-sm mb-4"
            >
              احصل على الكتاب الآن
            </Link>
            <br />
            <Link
              to="/"
              data-testid="welcome-cta-home"
              className="inline-block glass-button px-6 py-3 rounded-full font-body text-xs text-warm-brown border border-sacred-gold/20 hover:bg-sacred-gold/5"
            >
              ابدأ من البداية
            </Link>
          </ScrollReveal>
        </div>
      </section>

      {/* FINAL THANKS */}
      <section className="py-16 px-4 text-center" style={{ background: '#2C1810' }}>
        <ScrollReveal>
          <p className="text-lg italic max-w-md mx-auto leading-relaxed" style={{ fontFamily: "'Amiri', serif", color: '#A67C00' }}>
            شكراً لأنك وصلت إلى هنا.<br />هذا يعني أنك جاد.<br />وأنك تستحق كل ما هو قادم.<br /><br />
            <span className="text-sm" style={{ color: '#C9A84C' }}>بامتنان — طارق</span>
          </p>
        </ScrollReveal>
      </section>

      {/* FOOTER */}
      <section className="py-8 px-4 text-center" style={{ background: '#1a0f08', borderTop: '1px solid rgba(166,124,0,0.15)' }}>
        <p className="text-sm font-bold mb-1" style={{ color: '#C9A84C' }}>طارق أبو فياض</p>
        <p className="text-xs mb-1"><a href="https://tariqwithin.com" target="_blank" rel="noopener noreferrer" className="hover:underline" style={{ color: '#8B6914' }}>tariqwithin.com</a></p>
        <p className="text-xs"><a href="mailto:contact@tariqwithin.com" className="hover:underline" style={{ color: '#8B6914' }}>contact@tariqwithin.com</a></p>
      </section>
    </div>
  );
}
